
<template>
  <!--APP广告-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="banner_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img :style="{width: '30px', height: 'auto'}" :src="row.file_url" alt="">
      </template>

      <template slot="opt_o" slot-scope="{row}">
        <span v-if="row.city_id > 0">{{row.scope_area}}</span>

        <template v-else>
          <a-tooltip v-if="row.communityDesc.length > 1">
            <p slot="title" v-for="(item, index) of row.communityDesc" :key="index">{{item}}</p>
            <span>{{`指定小区：${row.communityDesc[0]}...`}}</span>
          </a-tooltip>
          <span v-else>{{row.scope_area}}</span>
        </template>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'advert',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '标题', inputType: 'input' },
        { props: ['module'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '', customRender: true, handle: (record) => this.changeStatus(record), key: 'status' },
        { text: '修改', handle: (record) => this.$children[0].toEdit(record), key: 'edit' },
        { text: '删除', handle: (record) => this.$children[0].showDeleteConfirm(record), key: 'delete' }
      ],
      columns: [
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用', dataIndex: 'app_type', align: 'left', width: '' },
        { title: '广告位', dataIndex: 'banner_space_desc', align: 'left', width: '' },
        { title: '广告图', dataIndex: 'file_url', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '投放范围', dataIndex: 'scope_area', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} },
        { title: '排序', dataIndex: 'order_id', align: 'left', width: '' },
        { title: '访客数', dataIndex: 'member_view_sum', align: 'left', width: '' },
        { title: '浏览量', dataIndex: 'pageview', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '创建人', dataIndex: 'send_user_name', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        module: '',
        status: '',
        create_date: ''
      },
      listApi: {
        url: '/banner',
        resHandle: this.urlResHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addAdvert',
        title: '修改APP广告'
      },
      deleteParam: {
        url: '/banner',
        param: { pk_key: 'banner_id', pk_val: '' },
        title: 'APP广告',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 切换状态 */
    changeStatus (row) {
      this.$put({
        url: `/banner/edit/${row.banner_id}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$children[0].getTableList();
      });
    },
    getSelect () {
      this.marketingManageSelect([{index: 1, key: 'banner_module_list'}]);
    },
    urlResHandle (res) {
      res.forEach((el) => {
        let scopeArr = el.scope_area.split(',');
        scopeArr[0].includes(':') && (scopeArr[0] = scopeArr[0].split(':')[1]);
        el.communityDesc = scopeArr;
        console.log('el.communityDesc: ', scopeArr);
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/advert/advert.vue